export default (speakers) => speakers.reduce((acc, val, ind) => (
    ind === 0
        ? `${val.firstname} ${val.lastname}`
        : `${acc}, ${val.firstname} ${val.lastname}`
), '');
